<template>
  <div class="CustomeServicePopup" v-if="isShow">
    <div class="customer-popup-box">
      <div class="customer-popup-title">您是否确定取消此次砍价</div>
      <div class="popbtn">
        <div 
        class="close-popup"
        @click="close"
        >取消</div>
        <div 
        class="cancle-popup"
        @click="cancelBargain"
        >确定</div>
        
      </div>
    </div>
    <div
      class="mask"
      @touchmove.prevent
      v-show="isShow"
      @click="close"
    ></div>
  </div>
</template>

<script>
export default {
  name: "CancelBargainPopup",
  props: {
    precustomerPopupActive:{
      type:Boolean,
      default:false
    },
    isShow:{
      type:Boolean,
      default:false
    },
    bargainItem:{
      type:Object,
      default(){
        return{}
      }
    }
  },
  data() {
    return {};
  },
  methods: {
    close: function() {
      this.$emit("closePrePopup");
    },
    cancelBargain(){
      this.$emit("cancelBargain",this.bargainItem);
    }
  }
};
</script>

<style scoped>
.popbtn{
  display: flex;
  width: 100%;
}
.popbtn div{
  width: 50%;
}
.CustomeServicePopup .customer-popup-box{
  position: fixed;
  width: 80%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 999;
  text-align: center;
  background: #fff;
  border-radius: .2rem;
  padding-top: .7rem;
}
.CustomeServicePopup .customer-popup-title{
  font-size: .34rem;
  font-weight: 500;
  padding-bottom: .32rem;
}
.CustomeServicePopup .close-popup{
  margin-top: .6rem;
  padding: .4rem 0;
  font-size: .32rem;
  border-top: .02rem solid #e4e4e4;
  border-right: .02rem solid #e4e4e4;
  color: #000;
  font-weight: 700;
}
.CustomeServicePopup .cancle-popup{
  margin-top: .6rem;
  padding: .4rem 0;
  font-size: .32rem;
  border-top: .02rem solid #e4e4e4;
  color: #576B95;
  font-weight: 700;
}
</style>
